export default {
  "Uvjeti":"Voorwaarden",
  "Account": "Račun",
  "DataProtection":"Zaštita podataka",
  "Privacy":"Privatnost",
  "Imprint":"Kontakt podaci",
  "Help":"Pomoć",
  "Contact":"Kontakt",
  "Deactivation":"Deaktivacija",
  "Action":"Akcija",
  "Terms":"Pravila i Uslovi",
  "T&C":"Pravila i Uslovi",
  "Adventure":"Avantura",
  "Guess":"Pogađanje",
  "Maximum score":"Maksimalni rezultat",
  "Platform":"Platforma",
  "Quiz":"Kviz",
  "Shooter":"Pucačina",
  "Ability":"Vještina",
  "Profile":"Profil",
  "Home":"Početna stranica",
  "Page visible only to registered users.":"Stranica je vidljiva samo registriranim korisnicima.",
  "PLAY NOW!":"IGRAJ SAD!",
  "Games in category {Category}":"Igre u kategoriji {Kategorija}",
  "To unsubscribe, enter your phone number in international format and submit the form": "Za otkazivanje pretplate unesite svoj telefonski broj u međunarodnom formatu i pošaljite obrazac",
  "If you want to cancel or have any questions about the service, send an email to: ": "Ako želite otkazati ili imate pitanja o usluzi, pošaljite E-Mail na",
  "You have successfully unsubscribed from the service": "Uspješno ste se odjavili sa servisa",
  "By registering I confirm that I am over 18 years old and I confirm that I have read and accept the terms and conditions and I hereby give up my right of withdrawal from the purchase of this product.": "Registracijom potvrđujem da sam stariji od 18 godina i potvrđujem da sam pročitao i prihvaćam uvjete i odredbe te se ovim odričem prava na odustajanje od kupnje ovog proizvoda.",
  "Subscription service. Sign up now and play the best games. Price is 6.00 EURO for 7 days. Payment is made through your mobile service provider. ": "Pretplatnička usluga. Prijavite se sada i igrajte najbolje igre. Cijena je 6,00 EUR za 7 dana. Plaćanje se vrši putem vašeg davatelja usluga mobilne telefonije.",
  "We cannot identify your phone number. Please turn off your WiFi and try again. ": "Ne možemo identificirati vaš telefonski broj. Isključite WiFi i pokušajte ponovo.",
  "Try again": "Pokušaj ponovno"
}


// WEBPACK FOOTER //
// ./src/i18n/ba.js